export function getScaledX({ xCoordinate, width, canvasWidth }) {
  const scaledX = (xCoordinate / width) * canvasWidth;
  return scaledX;
}

export function getScaledY({ yCoordinate, height, canvasHeight }) {
  const scaledY = (yCoordinate / height) * canvasHeight;
  return scaledY;
}

export function createColoredCircle({
  context,
  canvasHeight,
  canvasWidth,
  width,
  height,
  element,
  color,
  lineWidth,
  filled,
}) {
  context.lineWidth = 3; // Adjust the width if needed
  context.beginPath();
  context.arc(
    getScaledX({ canvasWidth, width, xCoordinate: element?.[0] }),
    getScaledY({ canvasHeight, height, yCoordinate: element?.[1] }),
    lineWidth,
    0,
    2 * Math.PI,
  );
  if (!filled) {
    context.strokeStyle = `${color}`;
  }
  if (filled) {
    context.fillStyle = color;
    context.fill();
  }
  context.stroke();
  context.closePath();
}

export function getWidthForVideoCanvas({ containerHeight, height, width }) {
  let newWidth = (containerHeight * 16) / 9;
  if (height > width) newWidth = (containerHeight * 9) / 16;
  if (width === height) {
    newWidth = containerHeight;
  }
  return newWidth;
}
